// Gravity constants (hard-coded for now)
export const hbar = 1.0;
export const m = 1.0;
export const g = 1.0;

